import { BentoCard, BentoGrid } from "@/components/ui/bento-grid";
import SectionHeader from '@/components/SectionHeader';
import { SimpleReveal } from '@/hooks/useSimpleAnimation';
import { useHomeData } from '../../hooks/useHomeData';
import { ClinicalApplicationsList } from '../ClinicalApplicationsList';

export const HomePlatformsSection = () => {
  const { platforms, clinicalApplications } = useHomeData();

  return (
    <>
      <section id="platforms" className="relative overflow-hidden section-spacing w-full bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <SimpleReveal>
            <div className="text-center mb-12">
              <SectionHeader title="Technology Platforms" subtitle="Our Delivery Platforms" className="mb-6" />
              <p className="text-section-description max-w-4xl mx-auto text-center">
                We offer a portfolio of advanced, customizable lipid-based technologies. Each platform is designed to enhance solubility, stability, and the overall performance of your API.
              </p>
            </div>
          </SimpleReveal>
          
          <SimpleReveal delay={100}>
            <BentoGrid>
              {platforms.map(feature => (
                <BentoCard key={feature.name} {...feature} />
              ))}
            </BentoGrid>
          </SimpleReveal>
        </div>
      </section>

      <section className="relative overflow-hidden section-spacing w-full bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SimpleReveal delay={200}>
            <div className="max-w-5xl mx-auto">
              <div className="text-center mb-12">
                <SectionHeader 
                  title="Clinical Applications" 
                  subtitle="Clinical Applications" 
                  className="mb-6" 
                />
                <p className="text-section-description max-w-4xl mx-auto text-center">
                  Our LBDDS technology unlocks new possibilities for pharmaceutical partners:
                </p>
              </div>
              
              <ClinicalApplicationsList applications={clinicalApplications} />
            </div>
          </SimpleReveal>
        </div>
      </section>
    </>
  );
};
